import { useGalleryFactory } from '@/model/GalleryFactory'
import type { Gallery } from '@/types/Gallery'
import { ref } from 'vue'
import type SwiperCore from 'swiper'

const { createDefault, resolveGalleryReload } = useGalleryFactory()

const gallery = ref(createDefault())
const loaded = ref(false)
const showThumbnails = ref(false)
const activeSlide = ref(0) // zero based index

export function useGalleryState() {
  const setGallery = (param: Gallery) => {
    gallery.value = param
    loaded.value = true
  }

  const isNavigationReloadForced = (swiper: SwiperCore | null = null): boolean => {
    if (!resolveGalleryReload()) return false

    if (null !== swiper && 'function' === typeof swiper.disable) {
      swiper.disable()
    }

    window.location.reload()
    return true
  }

  return {
    setGallery,
    gallery,
    loaded,
    activeSlide,
    showThumbnails,
    isNavigationReloadForced,
  }
}
